export default "__VITE_ASSET__hKThnb8b__"